import { createSortOption } from "@nosto/preact"
export const sizes = [12, 24, 48, 72, 96]

export const sortOptions = [
    createSortOption("Recommended", "Recommended", { field: "score", order: "desc" }),
    // createSortOption("Best Selling", "Best Selling", { field: "score", order: "desc" }),
    // createSortOption("Newest", "Newest", { field: "score", order: "desc" }),
    createSortOption("date", "Newest to Oldest", { field: "datePublished", order: "desc" }),
    createSortOption("price", "Price: Low to High", { field: "price", order: "asc" }),
    createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 6,
    autocompleteKeywordsSize: 6,
    historySize: 6
}
